module.exports = __webpack_public_path__ + "img/horizontal_4_4_8011.dde93ec9.png";